import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FleetService } from '../../../core/services/fleet.service';
import { TransferReservationService } from '../../../core/services/transfer-reservation.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../modules/auth/services/auth.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DriverService } from '../../../core/services/driver.service';
import * as _ from 'lodash';
import { CurrencyService } from '../../../core/services/currency.service';
import { PageSize } from '../../../core/dto/page.size';
import { ReportsService } from '../../../core/services/reports.service';
import { SETTINGS } from '../../../core/config/common.settings';
import { Pagination } from '../../../core/dto/pagination';
import { InventoryService } from '../../../core/services/inventory.service';

interface Vehicle {
  _id: string;
  model: string;
}

@Component({
  selector: 'app-view-single-booking',
  templateUrl: './view-single-booking.component.html',
  styleUrls: ['./view-single-booking.component.scss'],
})
export class ViewSingleBookingComponent implements OnInit {
  selectedReason = '';
  breadcrumbs: any[] = [];
  bookingData: any;
  loading = false;
  TransferBookingId: any;
  inventoryData: any[] = []; // Initialize with dummy data
  instructions = '';
  comment: any;
  visibleAddVehiclePopup = false;
  visibleAddDriverPopup = false;
  selectedSupplierId: any;
  preparingForInspection = false;
  selectedComment: any;
  selectedCommentIndex: any;
  availableDriver: any;
  supplierVehicleOptions: any[] = [];
  userComments: any[] = [];
  bookingPayments: any[] = [];
  isVisibleAddEditComment = false;
  addEditCommentModalType = 'add';
  isLoadingCommentModal = false;
  visibleCustomerModal = false;
  visibleDriverModal = false;
  visibleSupplierModal = false;
  supplierId = '';
  vehicleCat: any;
  allocationForm: FormGroup | any;
  availableVehicles = [
    { _id: '', vehicleName: '', currentMileage: 0, currentFuelLevel: 0 },
  ];
  endFuel = 0;
  endMileage = 0;
  selectedDriver = '';
  visiblePaymentPopup = false;
  isVisibleAddAllocation = false;
  isVisibleEndData = false;
  selectedSupplier: any;
  currencyOptions: any[] = [
    { value: 'USD', label: '$' },
    { value: 'EUR', label: '€' },
    { value: 'GBP', label: '£' },
    { value: 'CNY', label: '¥' },
    { value: 'LKR', label: 'Rs' },
  ];
  arrivalVeh = { model: '', reg: '' };
  departureVeh = { model: '', reg: '' };
  pageSize = new PageSize();
  allocationType = '';
  tempAllocation: any[] = [];
  isVisibleFuelAndMileageUpdate = false;
  changingStatus: any;
  selectedReservation: any;
  isLoading = false;
  fuelLevel = 0;
  mileage = 0;
  inventoryTracker: any; //TO see which item the before information should come from
  cancelReason: any = null;
  cancelReasonOptions: any[] = [
    'No Show',
    'No International License',
    'No Local License',
    'Vehicle Non Availability',
  ];
  index = 0;
  pdfLoader = false;
  isShowReport = false;
  pdf: any;

  isVisibleGenerateInventoryReport = false;
  fleetId: any;
  inventoryBookingData: any;

  // Paging board variables
  isVisibleGeneratePagingBoardModal = false;
  bookingCatSelectPagingBoardModal = false;
  defaultPagingBoardData: any;
  fleetsFetching = false;
  driversFetching = false;
  supplierVehiclesFetching = false;
  flag = '';
  haveInventoryRecords = false;
  haveInventoryRecordsDep = false;
  relevantInventoryId: any;

  // formatterPercentFuel = (value: number): string => `${value} %`;
  // parserPercentFuel = (value: string): string => value.replace(' %', '');
  // formatterDistance = (value: number): string => `${value} KM`;
  // parserDistance = (value: string): string => value.replace(' KM', '');

  constructor(
    private route: ActivatedRoute,
    private transferService: TransferReservationService,
    private router: Router,
    private authService: AuthService,
    private message: NzMessageService,
    private fb: FormBuilder,
    private fleetService: FleetService,
    private driverService: DriverService,
    private currencyService: CurrencyService,
    private messages: NzMessageService,
    private reportService: ReportsService,
    private inventoryService: InventoryService,
  ) {}

  ngOnInit(): void {
    this.TransferBookingId = this.route.snapshot.paramMap.get('id');

    this.loading = true;
    this.transferService
      .getTransferBookingById(this.TransferBookingId)
      .then((res) => {
        this.bookingData = res;
        this.setSupplierVehicle(res);
        this.setSupplierVehicleArrival(res);
        this.instructions = res.otherInformation.specialInstructions;
        this.userComments = res.otherInformation.userComments;
        this.bookingPayments = res?.payments?.sort(function (a: any, b: any) {
          return (
            new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime()
          );
        });
        this.getVehicleCat();
        this.allocationFormInit();
        // this.getCurrencyOptions();
        this.getDriverOptions();
        this.setBreadcrumbs();
        this.getCurrencyOptions();

        if (this.bookingData?.arrivalDetails?.allocatedVehicle) {
          this.inventoryService
            .getInventoryByFilter({
              fleet: this.bookingData?.arrivalDetails?.allocatedVehicle?._id,
              'before.inspectionDetails.bookingDetails.booking':
                this.bookingData?._id,
            })
            .then((res: any) => {
              this.relevantInventoryId = res?._id;
              this.haveInventoryRecords = !!res;
            });
        }

        if (this.bookingData?.departureDetails?.allocatedVehicle) {
          this.inventoryService
            .getInventoryByFilter({
              fleet: this.bookingData?.departureDetails?.allocatedVehicle?._id,
              'before.inspectionDetails.bookingDetails.booking':
                this.bookingData?._id,
            })
            .then((res: any) => {
              this.relevantInventoryId = res?._id;
              this.haveInventoryRecordsDep = !!res;
            });
        }
      });
  }

  setBreadcrumbs(): void {
    this.breadcrumbs = [
      {
        title: 'Transfer Booking',
        route: '/admin/booking-transfer',
      },
      {
        title: this.bookingData?.transferId,
      },
    ];
  }

  setSupplierVehicle(data: any) {
    if (data.departureDetails?.allocateDriver?._id) {
      this.loading = true;
      this.driverService
        .getSupplierVehiclesByDriver(data.departureDetails?.allocateDriver?._id)
        .subscribe((res) => {
          const temp = res?.supplierVehicles?.find(
            (vehicle: Vehicle) =>
              vehicle._id === data.departureDetails?.allocateVehicle,
          );
          this.departureVeh.model = temp?.vehicleModel;
          this.departureVeh.reg = temp?.registerNumber;
          this.loading = false;
        });
    }
  }

  getCurrencyOptions(): void {
    this.currencyService.getAllActiveCurrencies().subscribe((res: any) => {
      this.currencyOptions = res;
    });
  }

  setFlag(data: any): void {
    this.flag = data;
  }

  setSupplierVehicleArrival(data: any) {
    this.loading = true;
    this.driverService
      .getSupplierVehiclesByDriver(data.arrivalDetails?.allocateDriver?._id)
      .subscribe((res) => {
        const temp = res.supplierVehicles?.find(
          (vehicle: Vehicle) =>
            vehicle?._id === data?.arrivalDetails?.allocateVehicle,
        );
        this.arrivalVeh.model = temp?.vehicleModel;
        this.arrivalVeh.reg = temp?.registerNumber;
        this.loading = false;
      });
  }

  onGetAddPaymentChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visiblePaymentPopup = false;
        break;
      case 'created':
        // this.messages.create('success', 'New Payment has been added!');
        this.ngOnInit();
        this.visiblePaymentPopup = false;
        break;
    }
  }

  getTotalExtraCharges(): number {
    let total = 0;
    this.bookingData?.bookingCost?.extraCharges?.forEach((ec: any) => {
      const amount = ec?.currencyDetails
        ? ec?.amount * ec?.currencyDetails?.lkrRate
        : ec?.amount;
      total = total + amount;
    });
    return total;
  }

  getTotalDeductions(): number {
    let total = 0;
    this.bookingData?.bookingCost?.deductions?.forEach((de: any) => {
      const amount = de?.currencyDetails
        ? de?.amount * de?.currencyDetails?.lkrRate
        : de?.amount;
      total = total + amount;
    });
    return total;
  }

  getTotalAmount(): number {
    let total = 0;
    this.bookingData.bookingCost.extraCharges.forEach((cost: any) => {
      const amount = cost.amount;
      total += amount;
    });

    const transferRate = this.bookingData.bookingCost.transferRate;
    return total * transferRate;
  }

  navigateToSingleCustomer(data: any): void {
    this.router.navigate([`admin/customers/${data}`]);
  }

  editNavigate(data: any): void {
    const navigationExtras = {
      queryParams: {
        prev: 'single', // Replace 'your_value_here' with the actual value you want to pass
      },
    };
    this.router.navigate(
      [`admin/booking-transfer/add-edit/${data}`],
      navigationExtras,
    );
  }

  handleCancelAddEditComment(): void {
    this.isVisibleAddEditComment = false;
    this.comment = null;
  }

  visibleAddEditComment(type: string, comment?: any, index?: number): void {
    this.addEditCommentModalType = type;
    if (type === 'edit') {
      this.selectedComment = comment;
      this.comment = this.selectedComment?.comment;
      this.selectedCommentIndex = index;
    }
    this.isVisibleAddEditComment = true;
  }

  deleteComment(index: number): void {
    this.isLoadingCommentModal = true;
    this.userComments?.splice(index, 1);
    this.transferService
      .updateBooking({
        _id: this.TransferBookingId,
        otherInformation: {
          specialInstructions: this.instructions,
          userComments: this.userComments,
        },
      })
      .then(
        (res: any) => {
          this.isLoadingCommentModal = false;
          this.comment = null;
          this.message.create('success', 'Comment has been deleted!');
          this.ngOnInit();
        },
        (e: any) => {
          this.message.create('error', 'Error');
        },
      );
  }

  handleSubmitUserComment(): void {
    this.isLoadingCommentModal = true;
    if (this.addEditCommentModalType === 'add') {
      if (this.userComments?.length > 0) {
        this.userComments?.push({
          comment: this.comment,
          createdBy: this.authService.getLoggedInUser().userId,
          createdAt: new Date(),
        });
      } else {
        this.userComments = [
          {
            comment: this.comment,
            createdBy: this.authService.getLoggedInUser().userId,
            createdAt: new Date(),
          },
        ];
      }
      this.transferService
        .updateBooking({
          _id: this.TransferBookingId,
          otherInformation: {
            specialInstructions: this.instructions,
            userComments: this.userComments,
          },
        })
        .then(
          (res: any) => {
            this.isLoadingCommentModal = false;
            this.isVisibleAddEditComment = false;
            this.comment = null;
            this.message.create('success', 'New user comment has been added!');
            this.ngOnInit();
          },
          (e: any) => {
            this.message.create('error', 'Error');
          },
        );
    } else {
      this.userComments[this.selectedCommentIndex] = {
        createdAt: this.selectedComment?.createdAt,
        comment: this.comment,
        createdBy: this.authService.getLoggedInUser().userId,
      };
      this.transferService
        .updateBooking({
          _id: this.TransferBookingId,
          otherInformation: {
            specialInstructions: this.instructions,
            userComments: this.userComments,
          },
        })
        .then(
          (res: any) => {
            this.isLoadingCommentModal = false;
            this.isVisibleAddEditComment = false;
            this.comment = null;
            this.selectedComment = null;
            this.selectedCommentIndex = null;
            this.message.create('success', 'User comment has been updated!');
            this.ngOnInit();
          },
          (e: any) => {
            this.message.create('error', 'Error');
          },
        );
    }
  }

  editPayment(index: number, selectedPayment: any): void {
    this.visiblePaymentPopup = true;
  }

  visibleAddPayment(): void {
    this.visiblePaymentPopup = true;
  }

  CustomerModal(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleCustomerModal = false;
        break;
    }
  }

  DriverModal(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleDriverModal = false;
        break;
    }
  }

  SupplierModal(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleSupplierModal = false;
        break;
    }
  }

  showCustomerModal(): void {
    this.visibleCustomerModal = true;
  }

  showDriverModal(driver: any): void {
    this.selectedDriver = driver;
    this.visibleDriverModal = true;
  }

  showSupplierModal(supplier: any): void {
    console.log(supplier);
    this.selectedSupplier = supplier;
    this.visibleSupplierModal = true;
  }

  navigate(flag: string, marker: string): void {
    const navigationExtras = {
      queryParams: {
        booking: this.bookingData._id, // Replace 'your_value_here' with the actual value you want to pass
      },
    };

    if (marker === 'arrival') {
      if (flag === 'INSPECTION') {
        this.handleNavigateToNewInventory('arrival');
      } else {
        this.router.navigate(
          [
            `/admin/fleets/${this.bookingData?.arrivalDetails.allocatedVehicle?._id}/accidents/add-edit`,
          ],
          {
            queryParams: {
              from: 'view-single-booking',
              booking: this.bookingData?._id,
            },
          },
        );
      }
    } else {
      if (flag === 'INSPECTION') {
        this.handleNavigateToNewInventory('departure');
      } else {
        this.router.navigate(
          [
            `/admin/fleets/${this.bookingData?.departureDetails.allocatedVehicle?._id}/accidents/add-edit`,
          ],
          {
            queryParams: {
              from: 'view-single-booking',
              booking: this.bookingData?._id,
            },
          },
        );
      }
    }
  }

  async handleNavigateToNewInventory(nav: string): Promise<any> {
    this.router.navigate([
      `admin/fleets/${this.bookingData?.arrivalDetails?.allocatedVehicle._id}`,
      { pageName: 'fleetInventory' },
    ]);
    // if (nav === 'arrival') {
    //   this.preparingForInspection = true;
    //   const payload = Object.assign({}, new Pagination(this.pageSize), {
    //     sortOrder: -1,
    //     filters: {
    //       searchValue: '',
    //       fleetId: this.bookingData?.arrivalDetails?.allocatedVehicle._id,
    //     },
    //   });
    //   this.inventoryService
    //     .getInventoryPaged(payload)
    //     .then(async (res: any) => {
    //       this.inventoryData = await this.formatData(res.data);
    //       this.inventoryTracker = this.inventoryData.length;
    //
    //       if (this.inventoryData.length < 1) {
    //         this.preparingForInspection = false;
    //         this.router.navigate([
    //           `admin/fleets/${this.bookingData?.arrivalDetails?.allocatedVehicle._id}/inventory/add-edit`,
    //           { id: '', status: 'Booking', bookingId: this.bookingData },
    //         ]);
    //       } else {
    //         this.preparingForInspection = false;
    //         let temp;
    //         if (this.inventoryTracker === 1) {
    //           temp = 0;
    //         } else {
    //           temp = 1;
    //         }
    //         this.router.navigate([
    //           `admin/fleets/${this.bookingData?.departureDetails?.allocatedVehicle._id}/inventory/add-edit`,
    //           {
    //             id: '',
    //             status: 'Booking',
    //             prevRecId: this.inventoryData[temp]._id,
    //             bookingId: this.bookingData._id,
    //           },
    //         ]);
    //       }
    //     });
    // } else {
    //   this.preparingForInspection = true;
    //   const payload = Object.assign({}, new Pagination(this.pageSize), {
    //     sortOrder: -1,
    //     filters: {
    //       searchValue: '',
    //       fleetId: this.bookingData?.allocationDetails?.allocatedVehicle._id,
    //     },
    //   });
    //   this.inventoryService
    //     .getInventoryPaged(payload)
    //     .then(async (res: any) => {
    //       this.inventoryData = await this.formatData(res.data);
    //       this.inventoryTracker = this.inventoryData.length;
    //
    //       if (this.inventoryData.length < 1) {
    //         this.preparingForInspection = false;
    //         this.router.navigate([
    //           `admin/fleets/${this.bookingData?.allocationDetails?.allocatedVehicle._id}/inventory/add-edit`,
    //           { id: '', status: 'Booking', bookingId: this.bookingData },
    //         ]);
    //       } else {
    //         this.preparingForInspection = false;
    //         let temp;
    //         if (this.inventoryTracker === 1) {
    //           temp = 0;
    //         } else {
    //           temp = 1;
    //         }
    //         this.router.navigate([
    //           `admin/fleets/${this.bookingData?.allocationDetails?.allocatedVehicle._id}/inventory/add-edit`,
    //           {
    //             id: '',
    //             status: 'Booking',
    //             prevRecId: this.inventoryData[temp]._id,
    //             bookingId: this.bookingData._id,
    //           },
    //         ]);
    //       }
    //     });
    // }
  }

  formatData(documents: any[]): Promise<any[]> {
    return new Promise((resolve, reject) => {
      const initialDocs = documents.filter(
        (doc) => doc.before?.inspectionDetails?.reason === 'Initial',
      );
      const otherDocs = documents.filter(
        (doc) =>
          doc.before?.inspectionDetails?.reason !== 'Initial' &&
          doc.after?.inspectionDetails?.reason !== 'Final',
      );

      // Sort initialDocs and finalDocs
      initialDocs.sort((a, b) => a.createdAt - b.createdAt);

      // Sort otherDocs by createdAt in descending order
      otherDocs.sort((a, b) => b.createdAt - a.createdAt);
      resolve(initialDocs.concat(otherDocs));
      reject({ error: 'error' });
    });
  }

  handleCancelEndData(): void {
    this.allocationType = '';
    this.endMileage = 0;
    this.endFuel = 0;
    this.isVisibleEndData = false;
    this.isVisibleAddAllocation = false;
  }

  openEndDataModal(flag: any): void {
    this.allocationType = flag;
    if (
      (flag === 'Departure' &&
        this.bookingData.departureDetails?.driverCategory === 'SR_DRIVER') ||
      (flag === 'Arrival' &&
        this.bookingData.arrivalDetails?.driverCategory === 'SR_DRIVER')
    ) {
      if (flag === 'Departure') {
        this.endFuel = this.bookingData?.departureDetails?.allocatedVehicle
          ?.currentFuelLevel
          ? this.bookingData?.departureDetails?.allocatedVehicle
              ?.currentFuelLevel
          : 0;
        this.endMileage = this.bookingData?.departureDetails?.allocatedVehicle
          ?.currentMileage
          ? this.bookingData?.departureDetails?.allocatedVehicle?.currentMileage
          : 0;
      } else if (flag === 'Arrival') {
        this.endFuel = this.bookingData?.arrivalDetails?.allocatedVehicle
          ?.currentFuelLevel
          ? this.bookingData?.arrivalDetails?.allocatedVehicle?.currentFuelLevel
          : 0;
        this.endMileage = this.bookingData?.arrivalDetails?.allocatedVehicle
          ?.currentMileage
          ? this.bookingData?.arrivalDetails?.allocatedVehicle?.currentMileage
          : 0;
      }
      this.isVisibleEndData = true;
    } else {
      this.isVisibleAddAllocation = true;
    }
  }

  saveEndData(): void {
    this.isVisibleEndData = false;
    this.isVisibleAddAllocation = true;
  }

  handleCancelAllocation(): void {
    this.allocationType = '';
    this.endMileage = 0;
    this.endFuel = 0;
    this.isVisibleAddAllocation = false;
  }

  openAllocationModal(): void {
    this.isVisibleAddAllocation = true;
  }

  saveAllocation(): void {
    if (this.allocationType === 'Arrival') {
      this.tempAllocation = this.bookingData.arrivalDetails.allocationList;
      this.tempAllocation.push({
        vehicle: this.bookingData?.arrivalDetails?.allocatedVehicle?._id,
        driver: this.bookingData?.arrivalDetails?.allocateDriver?._id || null,
        startFuel: this.bookingData.arrivalDetails.startFuel,
        endFuel: this.endFuel,
        startMileage: this.bookingData.arrivalDetails.startMileage,
        endMileage: this.endMileage,
        driverVehModel: this.arrivalVeh.model || '',
        driverVehReg: this.arrivalVeh.reg || '',
        supplier:
          this.bookingData.arrivalDetails?.allocateDriver?.supplier
            ?.supplierDetails?.name || '',
        outRate: this.bookingData.arrivalDetails?.outsourcedRate || '',
      });

      const combinedValues = Object.assign(
        {},
        this.allocationForm.getRawValue(),
        {
          allocationList: this.tempAllocation,
          status: this.bookingData.arrivalDetails.status,
        },
      );

      const payload = {
        arrivalDetails: combinedValues,
        _id: this.bookingData._id,
        updateType: 'arrival_another_allocation',
      };

      this.transferService.updateBooking(payload).then(() => {
        this.isVisibleAddAllocation = false;
        this.ngOnInit();
      });
    } else if (this.allocationType === 'Departure') {
      this.tempAllocation = this.bookingData.departureDetails.allocationList;
      this.tempAllocation.push({
        vehicle: this.bookingData?.departureDetails?.allocatedVehicle?._id,
        driver: this.bookingData?.departureDetails?.allocateDriver?._id || null,
        startFuel: this.bookingData.departureDetails.startFuel,
        endFuel: this.endFuel,
        startMileage: this.bookingData.departureDetails.startMileage,
        endMileage: this.endMileage,
        driverVehModel: this.departureVeh.model || '',
        driverVehReg: this.departureVeh.reg || '',
        supplier:
          this.bookingData.departureDetails?.allocateDriver?.supplier
            ?.supplierDetails?.name || '',
        outRate: this.bookingData.departureDetails?.outsourcedRate || '',
      });

      const combinedValues = Object.assign(
        {},
        this.allocationForm.getRawValue(),
        {
          allocationList: this.tempAllocation,
          status: this.bookingData.departureDetails.status,
        },
      );

      const payload = {
        departureDetails: combinedValues,
        _id: this.bookingData._id,
        updateType: 'departure_another_allocation',
      };

      this.transferService.updateBooking(payload).then(() => {
        this.isVisibleAddAllocation = false;
        this.ngOnInit();
      });
    }
    this.endMileage = 0;
    this.endFuel = 0;
  }

  getVehicles(event: any): void {
    this.allocationForm.get('allocatedVehicle').setValue(null, {
      onlySelf: true,
      emitEvent: false,
    });
    this.fleetsFetching = true;
    this.fleetService
      .getFleetsAsOptions({ category: event })
      .then((res: any) => {
        this.fleetsFetching = false;
        this.availableVehicles = res;
      });
  }
  getVehicleFuelAndMileage = (event: any) => {
    const selectedData = this.availableVehicles.find(
      (val: any) => event?.toString() === val?._id?.toString(),
    );
    this.allocationForm
      .get('startMileage')
      .setValue(
        selectedData?.currentMileage ? selectedData?.currentMileage : 0,
      );
    this.allocationForm
      .get('startFuel')
      .setValue(
        selectedData?.currentFuelLevel ? selectedData?.currentFuelLevel : 0,
      );
  };

  getDriverOptions(event?: any): void {
    const payload = {
      driverSegment: event,
    };
    this.driversFetching = true;
    this.driverService.getDriverOptions(payload).subscribe((res: any) => {
      this.driversFetching = false;
      this.availableDriver = res;
    });

    if (
      this.allocationForm.get('driverAllocationCheck').value &&
      event === 'OUTSOURCE_DRIVER'
    ) {
      this.allocationForm.get('allocatedVehicle').setValue(null, {
        onlySelf: true,
        emitEvent: false,
      });
      this.allocationForm.get('allocatedVehicle').disable();
      this.allocationForm.get('vehicleCategory').disable();
      this.allocationForm.get('startMileage').disable();
      this.allocationForm.get('startFuel').disable();
    } else {
      this.allocationForm.get('allocatedVehicle').enable();
      this.allocationForm.get('vehicleCategory').enable();
      this.allocationForm.get('startMileage').enable();
      this.allocationForm.get('startFuel').enable();
    }
  }

  getVehicleCat(): void {
    this.loading = true;
    this.fleetService.getAllVehicleCat().then((res) => {
      this.vehicleCat = res;
      this.loading = false;
    });
  }

  getSupplierVehicles(event: any): void {
    if (
      this.allocationForm.get('driverCategory').value === 'OUTSOURCE_DRIVER' &&
      this.allocationForm.get('allocateDriver').value !== null
    ) {
      this.supplierVehiclesFetching = true;
      this.driverService
        .getSupplierVehiclesByDriver(event)
        .subscribe((res: any) => {
          this.supplierVehiclesFetching = false;
          this.supplierVehicleOptions = res?.supplierVehicles;
          this.supplierId = res?.supplierId;
          // }
        });
    }
  }

  // getCurrencyOptions(): void {
  //   this.currencyService.getAllActiveCurrencies().subscribe((res: any) => {
  //     this.currencyOptions = res;
  //   });
  // }

  allocationFormInit() {
    this.allocationForm = this.fb.group({
      vehicleCategory: [null],
      allocatedVehicle: [null, [Validators.required]],
      driverCategory: [null],
      startFuel: [0, [Validators.required]],
      startMileage: [0, [Validators.required]],
      driverAllocationCheck: [false, [Validators.required]],
      allocateDriver: [null],
      allocateVehicle: [null],
      outsourcedRate: [0],
      transferCurrency: ['65961e65cad7ae7c000623ff', []],
      transferCurrencyDetails: [null, []],
    });

    this.allocationForm.valueChanges.subscribe((values: any) => {
      if (values.transferCost) {
        const cu = this.currencyOptions?.find(
          (cu: any) => cu._id === values.transferCurrency,
        );
        this.allocationForm.get('transferCurrencyDetails').setValue(cu, {
          onlySelf: true,
          emitEvent: false,
        });
      }
    });

    this.allocationForm
      .get('driverAllocationCheck')
      .valueChanges.subscribe((value: any) => {
        this.allocationForm.get('allocatedVehicle').enable();
        this.allocationForm.get('vehicleCategory').enable();
        this.allocationForm.get('startMileage').enable();
        this.allocationForm.get('startFuel').enable();
        if (value) {
          // Reset values to null when driverAllocationCheck is true
          // this.allocationForm.get('driverCategory').setValue(null);
          // this.allocationForm.get('allocateDriver').setValue(null);
          // this.allocationForm.get('allocatedDriverVehicle').setValue(null);
          // this.allocationForm.get('outsourcedRate').setValue(null);
        }
      });

    this.allocationForm
      .get('driverCategory')
      .valueChanges.subscribe((value: any) => {
        if (value === 'SR_DRIVER') {
          // Reset values to null when driverAllocationCheck is true
          this.allocationForm.get('allocatedDriverVehicle').setValue(null);
          this.allocationForm.get('outsourcedRate').setValue(null);
          this.allocationForm.get('allocateDriver').setValue(null);
          this.allocationForm.get('allocatedVehicle').enable();
        } else {
          // this.allocationForm.get('allocatedVehicle').disable();
          this.allocationForm.get('allocateDriver').setValue(null);
          this.allocationForm.get('allocatedVehicle').setValue(null);
          this.allocationForm.get('vehicleCategory').setValue(null);
          this.allocationForm.get('startMileage').setValue(0);
          this.allocationForm.get('startFuel').setValue(0);
        }
      });

    this.allocationForm
      .get('allocateDriver')
      .valueChanges.subscribe((value: any) => {
        if (
          this.allocationForm.get('driverCategory').value ===
            'OUTSOURCE_DRIVER' ||
          this.bookingData.departureDetails.driverCategory ===
            'OUTSOURCE_DRIVER'
        ) {
          this.allocationForm.get('allocatedDriverVehicle').setValue(null);
        }
      });
  }

  convertToNormalString(text: string): string {
    return _.startCase(_.toLower(text));
  }

  handleOkSelectStatus(status: string, marker: any): void {
    this.selectedReason = marker;
    this.changingStatus = status;
    this.selectedReservation = this.bookingData;
    const currentDate = new Date();
    if (
      status === 'COMPLETED' &&
      ((marker === 'both' &&
        currentDate <
          new Date(
            this.bookingData?.tourDetails?.departureTourDetails
              ?.departureDateAndTime,
          )) ||
        (marker === 'single' &&
          currentDate <
            new Date(this.bookingData?.tourDetails?.arrivalDateAndTime)))
    ) {
      this.message.create(
        'warning',
        `You can not complete tour before the tour start and end date`,
      );
      return;
    }
    if (status === 'ON_TRANSFER' || status === 'COMPLETED') {
      if (
        (marker === 'both' &&
          this.bookingData.departureDetails?.driverCategory === 'SR_DRIVER') ||
        (marker === 'single' &&
          this.bookingData.arrivalDetails?.driverCategory === 'SR_DRIVER')
      ) {
        if (marker === 'both') {
          this.fuelLevel = this.selectedReservation?.departureDetails
            ?.allocatedVehicle?.currentFuelLevel
            ? this.selectedReservation?.departureDetails?.allocatedVehicle
                ?.currentFuelLevel
            : 0;
          this.mileage = this.selectedReservation?.departureDetails
            ?.allocatedVehicle?.currentMileage
            ? this.selectedReservation?.departureDetails?.allocatedVehicle
                ?.currentMileage
            : 0;
        } else if (marker === 'single') {
          this.fuelLevel = this.selectedReservation?.arrivalDetails
            ?.allocatedVehicle?.currentFuelLevel
            ? this.selectedReservation?.arrivalDetails?.allocatedVehicle
                ?.currentFuelLevel
            : 0;
          this.mileage = this.selectedReservation?.arrivalDetails
            ?.allocatedVehicle?.currentMileage
            ? this.selectedReservation?.arrivalDetails?.allocatedVehicle
                ?.currentMileage
            : 0;
        }
        this.isVisibleFuelAndMileageUpdate = true;
      } else {
        let details = {
          status: '',
        };
        if (
          this.selectedReason === 'both' ||
          this.selectedReservation.bookingDetails.bookingCategory ===
            'Departure'
        ) {
          details = this.selectedReservation?.departureDetails;
        } else if (
          this.selectedReservation.bookingDetails.bookingCategory === 'Arrival'
        ) {
          details = this.selectedReservation?.arrivalDetails;
        }

        details.status = status;
        let payload = {};
        if (
          this.selectedReason === 'both' ||
          this.selectedReservation.bookingDetails.bookingCategory ===
            'Departure'
        ) {
          payload = {
            departureDetails: details,
            _id: this.selectedReservation._id,
            updateType: 'departure_status_change',
          };
        } else {
          payload = {
            arrivalDetails: details,
            _id: this.selectedReservation._id,
            updateType: 'arrival_status_change',
          };
        }
        this.isLoading = true;
        this.transferService.updateBooking(payload).then(
          () => {
            this.isLoading = false;
            this.messages.create('success', `Status Changed to ${status}`);
            this.ngOnInit();
            this.changingStatus = null;
            this.selectedReservation = null;
          },
          () => {
            this.messages.create('error', 'Error');
          },
        );
      }
    } else if (status === 'CANCELLED') {
      this.isVisibleFuelAndMileageUpdate = true;
    } else {
      let statusCategory;
      if (
        marker === 'both' ||
        this.selectedReservation.bookingDetails.bookingCategory === 'Departure'
      ) {
        statusCategory = {
          departureDetails: {
            status: 'RESERVATION',
          },
          updateType: 'departure_status_change',
        };
      } else {
        statusCategory = {
          arrivalDetails: {
            status: 'RESERVATION',
          },
          updateType: 'arrival_status_change',
        };
      }
      this.transferService
        .updateBooking({
          _id: this.selectedReservation._id,
          ...statusCategory,
        })
        .then(
          () => {
            this.isLoading = false;
            this.messages.create(
              'success',
              'Status Changed to Transfer Booking',
            );
            this.ngOnInit();
            this.changingStatus = 0;
            this.selectedReservation = 0;
          },
          (e: any) => {
            this.messages.create('error', 'Error');
          },
        );
    }
  }

  handleCancelSelectStatus(): void {
    this.changingStatus = null;
    this.isVisibleFuelAndMileageUpdate = false;
  }

  checkCanShowGenerateInventoryReport(): boolean {
    return (
      _.includes(
        localStorage.getItem(SETTINGS.USER_PERMISSIONS),
        'REPORT_GENERATE',
      ) && this.haveInventoryRecords
    );
  }

  checkCanShowGenerateInventoryReportDep(): boolean {
    return (
      _.includes(
        localStorage.getItem(SETTINGS.USER_PERMISSIONS),
        'REPORT_GENERATE',
      ) && this.haveInventoryRecordsDep
    );
  }

  handleCancelUpdateFuelAndMileage(): void {
    this.isVisibleFuelAndMileageUpdate = false;
    this.fuelLevel = 0;
    this.mileage = 0;
    this.selectedReservation = null;
    this.changingStatus = null;
  }

  handleOkCancelledStatus(): void {
    this.isLoading = true;
    let remarks: any[] = this.selectedReservation?.remarks;

    if (remarks?.length > 0) {
      remarks?.push({
        action: `${this.flag} Cancelled`,
        remark: this.cancelReason,
        createdBy: this.authService.getLoggedInUser().userId,
      });
    } else {
      remarks = [
        {
          action: `${this.flag} Cancelled`,
          remark: this.cancelReason,
          createdBy: this.authService.getLoggedInUser().userId,
        },
      ];
    }
    this.flag = '';
    const payload: any = {
      _id: this.selectedReservation._id,
      remarks: remarks,
    };

    if (
      this.selectedReason === 'both' ||
      this.selectedReservation.bookingDetails.bookingCategory === 'Departure'
    ) {
      payload.departureDetails = this.bookingData.departureDetails;
      payload.departureDetails.status = 'CANCELLED';
      payload.updateType = 'departure_status_change';
    } else if (
      this.selectedReservation.bookingDetails.bookingCategory === 'Arrival'
    ) {
      payload.arrivalDetails = this.bookingData.arrivalDetails;
      payload.arrivalDetails.status = 'CANCELLED';
      payload.updateType = 'arrival_status_change';
    }

    this.transferService.updateBooking(payload).then(
      (res: any) => {
        this.isLoading = false;
        this.isVisibleFuelAndMileageUpdate = false;
        this.messages.create('success', 'Status Changed to Cancelled');
        this.ngOnInit();
        this.changingStatus = null;
        this.selectedReservation = null;
      },
      (e: any) => {
        this.messages.create('error', 'Error');
      },
    );
  }

  handleOkUpdateFuelAndMileage(): void {
    let flag = '';
    this.isLoading = true;
    let details = {
      startFuel: 0,
      endFuel: 0,
      startMileage: 0,
      endMileage: 0,
      status: '',
    };
    if (
      this.selectedReason === 'both' ||
      this.selectedReservation.bookingDetails.bookingCategory === 'Departure'
    ) {
      details = this.selectedReservation?.departureDetails;
      flag = 'dep';
    } else if (
      this.selectedReservation.bookingDetails.bookingCategory === 'Arrival'
    ) {
      details = this.selectedReservation?.arrivalDetails;
      flag = 'arrival';
    }

    if (this.changingStatus === 'ON_TRANSFER') {
      details.startFuel = this.fuelLevel;
      details.startMileage = this.mileage;
      details.status = 'ON_TRANSFER';
      let payload = {};
      if (
        this.selectedReason === 'both' ||
        this.selectedReservation.bookingDetails.bookingCategory === 'Departure'
      ) {
        payload = {
          departureDetails: details,
          _id: this.selectedReservation._id,
          updateType: 'departure_status_change',
        };
      } else {
        payload = {
          arrivalDetails: details,
          _id: this.selectedReservation._id,
          updateType: 'arrival_status_change',
        };
      }
      this.transferService.updateBooking(payload).then(
        (res: any) => {
          this.isLoading = false;
          this.updateFleetData('ON_TRANSFER', flag);
          this.messages.create('success', 'Status Changed to On Transfer');
          this.ngOnInit();
          this.isVisibleFuelAndMileageUpdate = false;
          this.changingStatus = null;
          this.selectedReservation = null;
          this.fuelLevel = 0;
          this.mileage = 0;
        },
        (e: any) => {
          this.messages.create('error', 'Error');
        },
      );
    } else if (this.changingStatus === 'COMPLETED') {
      details.endFuel = this.fuelLevel;
      details.endMileage = this.mileage;
      details.status = 'COMPLETED';
      let payload = {};
      if (
        this.selectedReason === 'both' ||
        this.selectedReservation.bookingDetails.bookingCategory === 'Departure'
      ) {
        payload = {
          departureDetails: details,
          _id: this.selectedReservation._id,
          updateType: 'departure_status_change',
        };
        flag = 'dep';
      } else {
        payload = {
          arrivalDetails: details,
          _id: this.selectedReservation._id,
          updateType: 'arrival_status_change',
        };
        flag = 'arrival';
      }
      this.transferService.updateBooking(payload).then(
        (res: any) => {
          this.isLoading = false;
          this.updateFleetData('COMPLETED', flag);
          this.messages.create('success', 'Status Changed to Completed');
          this.ngOnInit();
          this.isVisibleFuelAndMileageUpdate = false;
          this.changingStatus = null;
          this.selectedReservation = null;
          this.fuelLevel = 0;
          this.mileage = 0;
        },
        (e: any) => {
          this.messages.create('error', 'Error');
        },
      );
    }
  }

  updateFleetData(status: string, flag: any): void {
    let payload: any = {};
    if (status === 'ON_TRANSFER') {
      if (flag === 'arrival') {
        payload = {
          _id: this.bookingData?.arrivalDetails?.allocatedVehicle,
          currentMileage: this.mileage,
          currentFuelLevel: this.fuelLevel,
          currentOnBooking: {
            type: 'TRANSFER',
            id: this.bookingData?._id,
          },
          availabilityStatus: status,
        };
      } else if (flag === 'dep') {
        payload = {
          _id: this.bookingData?.departureDetails?.allocatedVehicle,
          currentMileage: this.mileage,
          currentFuelLevel: this.fuelLevel,
          currentOnBooking: {
            type: 'TRANSFER',
            id: this.bookingData?._id,
          },
          availabilityStatus: status,
        };
      }
    } else {
      if (flag === 'arrival') {
        payload = {
          _id: this.bookingData?.arrivalDetails?.allocatedVehicle,
          currentMileage: this.mileage,
          currentFuelLevel: this.fuelLevel,
          currentOnBooking: null,
          availabilityStatus: 'AVAILABLE',
        };
      } else if (flag === 'dep') {
        payload = {
          _id: this.bookingData?.departureDetails?.allocatedVehicle,
          currentMileage: this.mileage,
          currentFuelLevel: this.fuelLevel,
          currentOnBooking: null,
          availabilityStatus: 'AVAILABLE',
        };
      }
    }
    if (
      (this.bookingData?.arrivalDetails?.allocatedVehicle &&
        flag === 'arrival') ||
      (this.bookingData?.departureDetails?.allocatedVehicle &&
        flag === 'dep') ||
      status === 'COMPLETED'
    ) {
      this.fleetService.updateFleet(payload).then(() => {
        this.ngOnInit();
        this.isVisibleFuelAndMileageUpdate = false;
        this.changingStatus = null;
        this.fuelLevel = 0;
        this.mileage = 0;
      });
    }
  }

  addItem(input: HTMLInputElement): void {
    const value = input.value;
    if (this.cancelReasonOptions.indexOf(value) === -1) {
      this.cancelReasonOptions = [
        ...this.cancelReasonOptions,
        input.value || `New item ${this.index++}`,
      ];
    }
  }

  showReportGenerate(): void {
    this.isShowReport = true;
  }

  handleCancel(): void {
    this.isShowReport = false;
  }

  generatePdf(flag: any): void {
    this.pdfLoader = false;
    this.reportService
      .generateOutsourcedReport(this.bookingData, flag)
      .then((res) => {
        this.pdf = res;
        this.pdfLoader = true;
      });
  }

  emailPdf(): void {
    this.reportService.emailPdf();
    // const email = 'recipient@gmail.com';
    // const subject = 'Your email subject';
    // const body = 'Your email body content';
    //
    // // Create the mailto link
    // // Open the default email client (Gmail, if available)
    // window.location.href = `mailto:${email}?subject=${encodeURIComponent(
    //   subject,
    // )}&body=${encodeURIComponent(body)}`;
  }

  viewPdf(): void {
    this.reportService.viewReport(this.pdf);
  }

  downloadPdf(): void {
    this.reportService.downloadReport(this.pdf);
  }

  printReport(): void {
    this.reportService.printReport(this.pdf).then(() => {});
  }

  showGenerateInventoryReportPopup(fleet: any): void {
    this.fleetId = fleet;
    this.inventoryBookingData = {
      bookingId: this.bookingData?._id,
      bookingRefNo: this.bookingData?.transferId,
      onlyRecord: false,
    };
    this.isVisibleGenerateInventoryReport = true;
  }

  onGetGenerateInventoryReportChange(event: any): void {
    switch (event.name) {
      case 'visible':
        this.isVisibleGenerateInventoryReport = false;
        break;
    }
  }

  openBookingCatSelectPagingBoardModal() {
    if (
      this.bookingData.bookingDetails.bookingCategory === 'Arrival' &&
      this.bookingData.tourDetails.departureCheck === true
    ) {
      this.bookingCatSelectPagingBoardModal = true;
    } else {
      switch (this.bookingData.bookingDetails.bookingCategory) {
        case 'Arrival':
          this.openGeneratePagingBoardModal('Arrival');
          break;
        case 'Departure':
          this.openGeneratePagingBoardModal('Departure');
          break;
      }
    }
  }

  cancelBookingCatSelectPagingBoardModal() {
    this.bookingCatSelectPagingBoardModal = false;
  }

  openGeneratePagingBoardModal(category: string) {
    this.cancelBookingCatSelectPagingBoardModal();
    this.isVisibleGeneratePagingBoardModal = true;
    switch (category) {
      case 'Arrival':
        this.defaultPagingBoardData = {
          type: 'Arrival',
          customer:
            this.bookingData?.tourDetails?.customer?.renterDetails?.fullName,
          date: this.bookingData?.tourDetails?.arrivalFlightDate,
          time: this.bookingData?.tourDetails?.arrivalFlightTime,
          flight: this.bookingData?.tourDetails?.arrivalFlightNumber,
          dropLocation: this.bookingData?.tourDetails?.dropOffLocation,
          numOfPax: this.bookingData?.tourDetails?.noOfPassengers,
          vehicleCategory: this.bookingData?.tourDetails?.vehicleCategory,
          customerNumber:
            this.bookingData?.tourDetails?.customer?.renterDetails?.contactNo,
          agent: this.bookingData?.bookingDetails?.agent?.name,
        };
        break;
      case 'Departure':
        this.defaultPagingBoardData = {
          type: 'Departure',
          customer:
            this.bookingData?.tourDetails?.customer?.renterDetails?.fullName,
          date: this.bookingData.tourDetails.departureTourDetails
            .departureFlightDate,
          time: this.bookingData.tourDetails.departureTourDetails
            .departureFlightTime,
          flight:
            this.bookingData.tourDetails.departureTourDetails
              .departureFlightNumber,
          dropLocation:
            this.bookingData.tourDetails.departureTourDetails
              .departureDropOffLocation,
          numOfPax:
            this.bookingData.tourDetails.departureTourDetails
              .departureNoOfPassengers,
          vehicleCategory:
            this.bookingData.tourDetails.departureTourDetails
              .departureVehicleCategory,
          customerNumber:
            this.bookingData?.tourDetails?.customer?.renterDetails?.contactNo,
          agent: this.bookingData?.bookingDetails?.agent?.name,
        };
        break;
    }
  }

  onGetGeneratePagingBoardChange(event: any): void {
    switch (event.action) {
      case 'Invisible':
        this.isVisibleGeneratePagingBoardModal = false;
        break;
    }
  }

  havePermissionWithStatus(
    bookingStatus: any,
    permission: string,
    checkingStatus: string,
    have: boolean,
  ): boolean {
    if (have) {
      return (
        _.includes(
          localStorage.getItem(SETTINGS.USER_PERMISSIONS),
          permission,
        ) && bookingStatus === checkingStatus
      );
    } else {
      return (
        !_.includes(
          localStorage.getItem(SETTINGS.USER_PERMISSIONS),
          permission,
        ) && bookingStatus === checkingStatus
      );
    }
  }

  showAddDriverPopup(): void {
    this.driverService.initAddDriverPopupForm.next(true);
    this.visibleAddDriverPopup = true;
  }

  showAddVehiclePopup(): void {
    this.driverService.supplierVehicleFormType.next('add');
    this.visibleAddVehiclePopup = true;
  }

  onGetAddDriverChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleAddDriverPopup = false;
        break;
      case 'created':
        this.message.create('success', 'New Driver has been added!');
        this.getDriverOptions(this.allocationForm.get('driverCategory').value);
        this.visibleAddDriverPopup = false;
        break;
    }
  }

  getDriver(event: any) {
    this.driverService.getOneDriverById(event).then((res) => {
      if (res.supplier) {
        this.selectedSupplierId = res.supplier;
      }
    });
  }

  onGetAddVehicleChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleAddVehiclePopup = false;
        break;
      case 'submit':
        this.getSupplierVehicles(
          this.allocationForm.get('allocateDriver').value,
        );
        this.visibleAddVehiclePopup = false;
        break;
    }
  }

  cancelDeleteComment(): void {}
  editBtnDisableCheck(data: any) {
    if (
      data?.bookingDetails?.bookingCategory === 'Arrival' &&
      !data?.tourDetails?.departureCheck
    ) {
      return (
        data.arrivalDetails?.status === 'COMPLETED' ||
        data.arrivalDetails?.status === 'CANCELLED'
      );
    } else if (
      data?.bookingDetails?.bookingCategory === 'Arrival' &&
      data?.tourDetails?.departureCheck
    ) {
      return (
        (data?.arrivalDetails?.status === 'COMPLETED' &&
          data?.departureDetails?.status === 'COMPLETED') ||
        (data?.arrivalDetails?.status === 'CANCELLED' &&
          data?.departureDetails?.status === 'CANCELLED')
      );
    } else if (data?.bookingDetails?.bookingCategory === 'Departure') {
      return (
        data?.departureDetails?.status === 'COMPLETED' ||
        data?.departureDetails?.status === 'CANCELLED'
      );
    } else {
      return false;
    }
  }
}
